// extracted by mini-css-extract-plugin
module.exports = {"grid":"SectionAbout-module--grid--AcKWs","triangle":"SectionAbout-module--triangle--_wJHb"};